import { FiltersProvider } from "@/contexts/FilterContext";
import { Outlet } from "react-router-dom";

const FiltersRoutesWrapper = () => {
  return (
    <FiltersProvider>
      <Outlet />
    </FiltersProvider>
  );
};

export default FiltersRoutesWrapper;
